import { z } from 'zod';
import type { TFunction } from 'i18next';

const FOLDER_NAME_MAX_LENGTH = 255;

// A factory, not a module-scope const: building the schema at import time would bake
// in whatever language was active then, and the messages could never follow a change.
export const buildMarkBriefReadyFormSchema = (t: TFunction<'projects'>) =>
  z.object({
    name: z
      .string()
      .trim()
      .min(1, t('projectBriefDetail.markBriefReadyDialog.folderNameIsRequired'))
      .max(
        FOLDER_NAME_MAX_LENGTH,
        t('projectBriefDetail.markBriefReadyDialog.nameIsTooLong', {
          max: FOLDER_NAME_MAX_LENGTH,
        }),
      ),
  });

export type MarkBriefReadyFormData = z.infer<ReturnType<typeof buildMarkBriefReadyFormSchema>>;
